export const RESET_MFA_STATE = 'RESET_MFA_STATE'

export const REQUEST_OTP_VERIFICATION = 'REQUEST_OTP_VERIFICATION'

export const SEND_OTP = 'SEND_OTP'
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS'
export const SEND_OTP_FAIL = 'SEND_OTP_FAIL'
export const VERIFY_OTP = 'VERIFY_OTP'
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS'
export const VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL'

export const defaultMfaState = {
  mfaVerificationRequested: false,
  mfaEmailAddress: null,
  mfaContactNumber: null,
  mfaVerified: false,
  tempData: null
}

export default (state = defaultMfaState, action) => {
  switch (action.type) {
    case RESET_MFA_STATE: {
      return {
        ...state,
        mfaVerificationRequested: false,
        mfaEmailAddress: null,
        mfaContactNumber: null,
        mfaVerified: false,
        mfaError: null,
        tempData: null,
      }
    }

    case SEND_OTP: {
      return {
        ...state,
        // mfaUsername: action.payload.request.data.username,
      }
    }
    case VERIFY_OTP_SUCCESS: {
      return {
        ...state,
        mfaVerified: true,
        mfaError: null,
      }
    }
    case VERIFY_OTP_FAIL: {
      return {
        ...state,
        mfaVerified: false,
        mfaError: "failed"
      }
    }

    case REQUEST_OTP_VERIFICATION: {
      return {
        ...state,
        mfaVerificationRequested: true,
        mfaEmailAddress: action.payload.data.emailAddress,
        mfaContactNumber: action.payload.data.contactNumber,
        tempData: action.payload.data.tempData
      }
    }
    default:
      return state
  }
}
